import ComposeBlast from "../../../../components/EmailBlast/ComposeBlast/ComposeBlast";

export default function ComposeBlastPage() {
  return <ComposeBlast />;
}
